import { format, isAfter, isBefore } from 'date-fns'

import { EMPTY_STRING } from '../../../constants/common'
import { DATE_INPUT_FORMAT } from '../../../constants/date'
import { matchDateInput } from '../../../utils/date'

/**
 * @param {Date | null} date
 *
 * @returns {string}
 */
export function formatDateInputValue(date) {
  return date == null ? EMPTY_STRING : format(date, DATE_INPUT_FORMAT)
}

/**
 * @param {string} string
 * @param {{maxValue: Date | null, minValue: Date | null, timeZone: string}} options
 *
 * @returns {Date | null}
 */
export function parseDateInputValue(
  string,
  { createDate, maxValue, minValue, timeZone }
) {
  const match = matchDateInput(string)

  if (match) {
    const value = createDate(timeZone, match.year, match.month, match.day)

    if (minValue == null || maxValue == null || !isAfter(minValue, maxValue)) {
      const isBeforeMin = minValue != null && isBefore(value, minValue)
      const isAfterMax = maxValue != null && isAfter(value, maxValue)

      return isBeforeMin && isAfterMax
        ? null
        : isBeforeMin
          ? minValue
          : isAfterMax
            ? maxValue
            : value
    }
  }

  return null
}
